{
  "moreActions": "Mais ações",
  "unavailable": "Indisponível. Expanda para ver os detalhes"
}
